export default class {
  setKey(key, value) {
    return localStorage.setItem(key, value);
  }

  getKey(key) {
    return localStorage.getItem(key);
  }

  clear() {
    return localStorage.clear();
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/LocalStorageService.js